// assets
import { TeamOutlined, DollarOutlined, DotChartOutlined, ApiOutlined } from '@ant-design/icons';

// icons
const icons = {
  TeamOutlined,
  DollarOutlined,
  DotChartOutlined,
  ApiOutlined
};

// ==============================|| MENU ITEMS - ADMIN ||============================== //

const admin = {
  id: 'group-admin',
  title: 'Admin only',
  type: 'group',
  roles: ['admin'],
  children: [
    {
      id: 'clients',
      title: 'Clients',
      type: 'item',
      url: '/clients',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'pricings',
      title: 'Pricings',
      type: 'item',
      url: '/pricings',
      icon: icons.DollarOutlined,
      breadcrumbs: false
    },
    {
      id: 'endpoints',
      title: 'Endpoints',
      type: 'item',
      url: '/endpoints',
      icon: icons.ApiOutlined,
      breadcrumbs: false
    },
    {
      id: 'digital-twins',
      title: 'Digital twins',
      type: 'item',
      url: '/digital-twins',
      icon: icons.DotChartOutlined,
      breadcrumbs: false
    }
  ]
};

export default admin;
